module.exports = __webpack_public_path__ + "static/media/footer-logo.54319311.svg";